import { createContext, useContext } from 'react';
import {
    ApiQueryFormResponse,
    QueryableEntityType,
    SetQueryFormValuesHandler,
} from 'mark43-federated-search';

export type FederatedSearchQueryFormsContextValue = {
    queryForms: ApiQueryFormResponse[];
};

export type FederatedSearchNotificationsContextValue = {
    unreadQueriesIncludeSpecialResult: boolean;
    unreadQueryCount: number;
    markAllQueriesAsRead: () => Promise<void>;
};

export const federatedSearchQueryFormsContextDefaultValue: FederatedSearchQueryFormsContextValue = {
    queryForms: [],
};

export const FederatedSearchQueryFormsContext = createContext<FederatedSearchQueryFormsContextValue>(
    federatedSearchQueryFormsContextDefaultValue
);

export const useFederatedSearchQueryForms = () => {
    return useContext(FederatedSearchQueryFormsContext);
};

export const FederatedQueryIdsContext = createContext<string[]>([]);

export function useFederatedQueryIds() {
    return useContext(FederatedQueryIdsContext);
}

export const FederatedSearchNotificationsContext = createContext<FederatedSearchNotificationsContextValue>(
    {
        unreadQueryCount: 0,
        unreadQueriesIncludeSpecialResult: false,
        markAllQueriesAsRead: async () => {},
    }
);

export function useFederatedSearchNotifications() {
    return useContext(FederatedSearchNotificationsContext);
}

export type FederatedSearchActionsContextValue = {
    setSelectedForm: (type: QueryableEntityType, field: string) => void;
    setQueryFormValues: SetQueryFormValuesHandler | null;
};

export const FederatedSearchActionsContext = createContext<FederatedSearchActionsContextValue | null>(
    null
);

export const useFederatedSearchActions = () => {
    return useContext(FederatedSearchActionsContext);
};
